import { defineComponent } from "vue";
import InputWidget from "./InputWidget";

export default defineComponent({
    components: {
        InputWidget,
    },

    template: `
        <InputWidget :label="label" :required="required" class="InputRadio">
            <div class="InputRadio__items">
                <label v-for="item in items" class="InputRadio__item" :class="{ 'InputRadio__item--selected': modelValue == item.id }">
                    <span class="InputRadio__dot"></span>

                    <input type="radio" :name="name" :value="item.id" :checked="modelValue == item.id" @input="$emit('update:modelValue', item.id)" class="InputRadio__input" :required="required" />

                    <span v-html="item.label"></span>
                </label>
            </div>
        </InputWidget>
    `,

    emits: [
        'update:modelValue',
    ],

    props: {
        items: { type: Object, requried: true },
        name: { type: String, requried: true },

        modelValue: { type: [String, Number] },
        label: { type: String },

        required: { type: Boolean },
    },
});
